import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { forexApi, type FollowRelationDTO } from '@/services/forexApi';
import SubscriptionStatus from './SubscriptionStatus';

export default function FollowAttention() {
  const { accessToken } = useAuth();
  const [relations, setRelations] = useState<FollowRelationDTO[]>([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    setRelations([]); setError(false); setLoading(true);
    if (!accessToken) { setLoading(false); return; }
    void forexApi.listFollowRelations(accessToken)
      .then(items => { if (active) setRelations(items.filter(r => r.execution_schema === 'account_parallel' && r.follow_status !== 'stopped')); })
      .catch(() => { if (active) setError(true); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [accessToken, retry]);
  if (!accessToken) return null;
  return <section className="mx-5 mt-4 rounded-2xl bg-white p-4" aria-label="跟随与授权">
    <div className="flex items-center justify-between gap-3"><h2 className="font-semibold text-gray-900">跟随与授权</h2><Link to="/agent?tab=my-copy" className="inline-flex min-h-11 items-center text-sm text-indigo-600">查看全部</Link></div>
    {loading && <p role="status" className="text-sm text-gray-500">正在读取账户状态…</p>}
    {error && <div role="alert" className="text-sm text-amber-700">跟随状态暂不可用。<button type="button" onClick={() => setRetry(n => n + 1)} className="min-h-11 px-3">重试</button></div>}
    {!loading && !error && !relations.length && <Link className="inline-flex min-h-11 items-center text-sm text-indigo-600" to="/agent">暂无跟随，浏览平台 Agent</Link>}
    {relations.slice(0, 3).map(relation => <div key={relation.id} className="mt-3"><p className="text-xs text-gray-500">账户 {relation.account_id}</p><SubscriptionStatus relationId={relation.id} agentId={relation.agent_id} /></div>)}
  </section>;
}
